export default "__VITE_ASSET__42a02949__"